import { useSelector } from 'react-redux'
import { get } from 'lodash'
import { useTranslation } from 'react-i18next'
import { usesTenantDashboardUi } from 'lib/auth/dashboardRole'

const PageFooter = ({ currentPage, totalPages, totalRecords }) => {
  const { t } = useTranslation()
  const userFromStore = useSelector(state => get(state, 'user.user'))
  const usesTenantUi = usesTenantDashboardUi(userFromStore)

  if (!currentPage || !totalPages) return null

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 w-full max-w-sm px-4 sm:max-w-md md:max-w-lg z-[1100]">
      <div>
        <div className="flex justify-center">
          <span className="inline-flex items-center justify-center rounded-full bg-red-100 text-red-800 px-1.5 py-0.5 text-xs sm:text-sm font-medium border border-red-300">
            <div className="flex items-center space-x-1 sm:space-x-2">
              <span className="">{usesTenantUi ? t('common.pagination.page') : 'Page'}</span>
              {/* <span className="xs:hidden">P</span> */}
              <span>{currentPage}</span>
              <span className="hidden xs:inline">{usesTenantUi ? t('common.pagination.of') : 'of'}</span>
              <span className="xs:hidden">/</span>
              <span>{totalPages}</span>
              <span className="hidden sm:inline">|</span>
              <span className="hidden sm:inline">{usesTenantUi ? t('common.pagination.totalRecords') : 'Total Records:'}</span>
              <span className="hidden sm:inline">{totalRecords}</span>
              <span className="sm:hidden">{totalRecords}</span>
            </div>
          </span>
        </div>
      </div>
    </div>
  )
}

export default PageFooter
